import BehaviorConfig from '@/models/app-config/behavior/behavior'
import { HlAppMode } from '@/models/hl-app/hl-app-mode'
import { EligibilityChecker, EligibilityCheckStrategy } from './base'

export interface ContextForEnvironmentLayer {
  behavior: Pick<BehaviorConfig, 'orderHistory'>
  hlAppMode: typeof HlAppMode
}

export class EligibilityCheckerForEnvironmentLayer extends EligibilityChecker<ContextForEnvironmentLayer> {}

export class EligibleWhenBehaviorIsEnabled implements EligibilityCheckStrategy<ContextForEnvironmentLayer> {
  check(context: ContextForEnvironmentLayer): boolean {
    return context.behavior.orderHistory.addToCartButton.enabled
  }
}

export class EligibleWhenNotViewedInHlAppWebView implements EligibilityCheckStrategy<ContextForEnvironmentLayer> {
  check(context: ContextForEnvironmentLayer): boolean {
    return !context.hlAppMode.isViewedInHlAppWebView
  }
}
